import axios from "axios"
import { ticketBaseURL } from "../config/api";

export const post_Incident = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}incident?${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_Incident = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}incident?${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getIncidentsReportByTenantIdByAppName = (appName: string, tenantId: string, page: number, size: number) => {
    return getFetch(`incident/GetIncidentsReportByTenantIdAndByAppName/${appName},${tenantId},${page},${size}`)
}

export const getIncidentsReportByTenantIdByAppNameWithStatus = (status: string, appName: string, tenantId: string, page: number, size: number) => {
    return getFetch(`incident/GetIncidentsReportByTenantIdAndByAppNameWithStatus/${status},${appName},${tenantId},${page},${size}`)
}

export const getIncidentsReportByTenantIdByAppNameAndSearchWithIncidentName = (searchValue: string, appName: string, tenantId: string, page: number, size: number) => {
    return getFetch(`incident/GetIncidentsReportByTenantIdAndByAppNameAndSearchWithIncidentName/${searchValue},${appName},${tenantId},${page},${size}`)
}

export const getIncidentsReportByTenantIdByAppNameWithStatusAndSearchWithIncidentName = (searchValue: string, status: string, appName: string, tenantId: string, page: number, size: number) => {
    return getFetch(`incident/GetIncidentsReportByTenantIdAndByAppNameWithStatusAndSearchWithIncidentName/${searchValue},${status},${appName},${tenantId},${page},${size}`)
}


export const getIncidentById = (primaryKey: number) => {
    return getFetch(`incident/${primaryKey}`)
}

const getFetch = async (url: string, params = {}) => {
    const response = await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    });
    return response.data;
}